var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file [Please Input File Description]
 * @author (zhuwanying02) if any problem, please call me.
 */

import React, { Component, Fragment } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'lodash-es';
import './Navbar.less';
import Sidebar from '../Sidebar';
import { classPrefix } from '../../common/util';
/*
 *  参数说明
 *  dataSource          必需，数据源，对象数组
 *  selectedKeys  可选，默认选中，字符串数组
 *  onHandleSelect      必需，选中后的回调函数
 *  defaultHoveredKey   可选，下拉选项默认hover项，字符串数组
 *  className           可选，传入类自定义，字符串
 *  classPrefix         可选，类名前缀
 */

var NavbarContent = function (_Component) {
    _inherits(NavbarContent, _Component);

    function NavbarContent() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, NavbarContent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NavbarContent.__proto__ || Object.getPrototypeOf(NavbarContent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isShowSidebar: false
        }, _this.showSidebar = function () {
            _this.setState({ isShowSidebar: !_this.state.isShowSidebar });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(NavbarContent, [{
        key: 'handleClick',
        value: function handleClick(e) {
            var onHandleSelect = this.props.onHandleSelect;

            if (onHandleSelect && _.isFunction(onHandleSelect)) {
                onHandleSelect(e);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                dataSource = _props.dataSource,
                className = _props.className,
                classPrefix = _props.classPrefix,
                zIndex = _props.zIndex,
                attributes = _objectWithoutProperties(_props, ['dataSource', 'className', 'classPrefix', 'zIndex']);

            var cx = classnames(className, _defineProperty({}, classPrefix + '-navbar-content', true));
            var buttonClass = classnames({
                'navbar-responsive-button': true,
                'button-close': this.state.isShowSidebar
            });
            if (this.context.responsive) {
                return React.createElement(
                    'div',
                    { className: 'navbar-content', style: { zIndex: zIndex } },
                    this.context.miniType ? React.createElement(
                        Fragment,
                        null,
                        this.state.isShowSidebar && React.createElement(Sidebar, _extends({ className: cx,
                            theme: 'light',
                            dataSource: dataSource,
                            onHandleClick: this.handleClick.bind(this),
                            classPrefix: classPrefix,
                            inNavbar: true
                        }, attributes)),
                        React.createElement('div', { className: buttonClass,
                            onClick: this.showSidebar
                        })
                    ) : React.createElement(Sidebar, _extends({ className: cx,
                        horizontal: true,
                        dataSource: dataSource,
                        onHandleClick: this.handleClick.bind(this),
                        classPrefix: classPrefix
                    }, attributes))
                );
            } else {
                return React.createElement(Sidebar, _extends({ className: cx,
                    horizontal: true,
                    dataSource: dataSource,
                    onHandleClick: this.handleClick.bind(this),
                    classPrefix: classPrefix
                }, attributes));
            }
        }
    }]);

    return NavbarContent;
}(Component);

NavbarContent.propTypes = {
    className: PropTypes.string,
    classPrefix: PropTypes.string,
    selectedKeys: PropTypes.arrayOf(PropTypes.string),
    defaultHoveredKey: PropTypes.arrayOf(PropTypes.string),
    dataSource: PropTypes.arrayOf(PropTypes.object).isRequired,
    onHandleSelect: PropTypes.func,
    zIndex: PropTypes.number
};
NavbarContent.defaultProps = {
    dataSource: [],
    classPrefix: classPrefix
};
NavbarContent.contextTypes = {
    responsive: PropTypes.bool,
    miniType: PropTypes.bool
};
export default NavbarContent;